@if (isMobileApp) {
  @if (user.buys && !user.purchaseBlocked) {
    <div
      class="rich-club-container"
      (click)="openAppchargeLanding()">
      @if (bonusAvailable) {
        <slotcom-badge></slotcom-badge>
      }
      <div
        class="c-icon active"
        [@pulse]="state()"></div>
    </div>
  } @else {
    <div
      class="rich-club-container"
      (click)="tooltip.toggle()"
      #tooltip="slotcomTooltip"
      [slotcomTooltip]="'home.rich-club-icon.tooltip-blocked' | translate"
      [slotcomTooltipPosition]="toolTipPosition === 'right' ? 'right' : 'left'"
      [slotcomTooltipClass]="
        'slotcom-tooltip--long ' + (toolTipPosition === 'right' ? 'slotcom-tooltip--left' : 'slotcom-tooltip--right')
      ">
      <div class="c-icon locked"></div>
      <div class="blocked-icon"></div>
    </div>
  }
}
